import styled from '@emotion/styled';
import { Menu } from '@mui/material';
import { colors } from 'theme/colors';
import Button from '../../atoms/Button';

const StyledMenu = styled(Menu)`
  & > .MuiPaper-root {
    width: max-content;
    min-width: 155px;
    margin-top: 4px;
    border: 1px solid ${colors.primary500};
    box-shadow:
      0px 2px 4px rgba(194, 204, 243, 0.15),
      0px 2px 4px rgba(194, 204, 243, 0.15),
      0px 4px 4px rgba(194, 204, 243, 0.15),
      0px 6px 6px rgba(194, 204, 243, 0.15);
    border-radius: 4px;
  }

  & .MuiList-root {
    padding: 4px;
  }

  & .MuiMenuItem-root {
    height: 32px;
    min-height: 32px;
    box-sizing: border-box;
    padding: 6px 8px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  & .MuiMenuItem-root .MuiListItemIcon-root {
    min-width: 0;
    margin: 0;
  }

  & .MuiListItemText-root {
    margin: 0;
  }

  & .MuiListItemText-root .MuiTypography-root {
    font-size: 14px;
    line-height: 20px;
    color: ${colors.primary900};
  }
`;

const StyledButton = styled(Button)`
  & svg {
    width: 24px;
    margin-left: 7px;
    margin-top: 6px;
    color: ${colors.primary900};
  }
`;

export { StyledMenu, StyledButton };
